import React from 'react'
import { Container } from 'react-bootstrap'
import "./Banner.css"

const Banner = () => {
    return (
        <div className='container-fluid p-0'>
            <img src='/assets/images/about_us/banner-2.png' alt='banner-img' className='banner_img' />
            <div className='about_text_holder'>
                <p className='about_text'>
                    Through the continuous refinement of our safety systems-including
                    rigorous driver vetting, real-time vehicle monitoring, and proactive
                    service checks-we strive to make sure every trip is a secure and positive one for you.
                </p>
            </div>
        </div>
    )
}

export default Banner